export const KEY_CODE_ESCAPE = 27;
export const KEY_CODE_ENTER = 13;
export const KEY_CODE_UP = 38;
export const KEY_CODE_DOWN = 40;
